import {
  FormControl,
  FormField,
  FormItem,
  FormLabel,
  FormMessage,
} from '@/components/ui/Form';
import InstructionHint from '@/components/ui/InstructionHint';
import MultiTextInput from '@/components/ui/MultiTextInput';

import { useLingui } from '@lingui/react';
import { useFormContext } from 'react-hook-form';

export const DAMAGE_BEFORE_ACCIDENT_NAME_COMPLEMENTARY =
  'damages_before_accident_complementary';

export const InputDamageBeforeAccidentComplementary = ({
  name = DAMAGE_BEFORE_ACCIDENT_NAME_COMPLEMENTARY,
}: {
  name?: string;
}) => {
  const { i18n } = useLingui();
  const { control } = useFormContext();

  return (
    <FormField
      control={control}
      name={name}
      rules={{
        required: {
          value: true,
          message: i18n.t('Uzupełnij to pole, aby zakończyć formularz'),
        },
      }}
      defaultValue={[]}
      render={({ field }) => (
        <FormItem>
          <FormLabel>{i18n.t('Co było uszkodzone przed szkodą?')}</FormLabel>
          <InstructionHint
            title={i18n.t('Napisz coś i zatwierdź, klikając ENTER.')}
          />
          <FormControl>
            <MultiTextInput
              id={name}
              {...field}
              success={!!field.value?.length}
              data-testid="input-damage-before-accident-complementary"
            />
          </FormControl>
          <FormMessage />
        </FormItem>
      )}
    />
  );
};
